export enum DeliveryStatusText {
  AWAITING_EVALUATION = 'AGUARDANDO AVALIAÇÃO',
  PENDING_STUDENT_CORRECTION = 'CORREÇÃO PENDENTE DO ALUNO',
  IN_RECOVERY = 'EM RECUPERAÇÃO',
  EXPIRED = 'EXPIRADO',
  NOT_STARTED = 'NÃO INICIADO',
  PUBLISHED = 'PUBLICADO',
  DRAFT = 'RASCUNHO SALVO DO ALUNO',
}
